"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClipStatus = void 0;
var ClipStatus;
(function (ClipStatus) {
    ClipStatus["NoData"] = "events.table.status.no_data";
    ClipStatus["Waiting"] = "events.table.status.waiting_for_data";
    ClipStatus["WaitingUrgent"] = "events.table.status.waiting_for_data_urgent";
    ClipStatus["DueNow"] = "events.table.status.due_now";
    ClipStatus["InProgress"] = "events.table.status.in_progress";
    ClipStatus["Uploaded"] = "events.table.status.uploaded";
    ClipStatus["Available"] = "events.table.status.available";
})(ClipStatus = exports.ClipStatus || (exports.ClipStatus = {}));
//# sourceMappingURL=clip-status.js.map